export default "__VITE_ASSET__DXNWB9DB__"